		/**
		 * @ngdoc service
		 * @constructor
		 * @name WebCoreModule.service:WcDateRangePickerPrototype
		 * @requires $rootScope
		 * @param {Object} config Config parameters to pass in to the prototype being created
		 * @returns {WcDateRangePickerPrototype} The prototype created with the passed in information. The returned WcDateRangePickerPrototype
		 * will expose the following properties and methods:
		 * @description
		 * The WcDateRangePickerPrototype provides a way to create paired date picker inputs for range selection. The pickers are
		 * aware of the dates picked in either picker and disallow selections that are then out of range.
		 *
		 * To leverage the WcDateRangePickerPrototype, create a new instance using 'new WcDateRangePickerPrototype()' in calling code.
		 * The WcDateRangePickerPrototype constructor creates a new instance of the WcDateRangePickerPrototype. This prototype
		 * establishes the necessary properties and functions for rendering paired date pickers in your view.
		 */

angular.module('WebCoreModule')
	.factory('WcDateRangePickerPrototype', ['$rootScope',

	function($rootScope) {
		function WcDateRangePickerPrototype(config) {
			var startDate, endDate, minDate, maxDate, startDateFieldName, endDateFieldName, form;

			if(config) {
				startDate = config.startDate ? config.startDate : null;
				endDate = config.endDate ? config.endDate : null;
				minDate = config.minDate ? config.minDate : null;
				maxDate = config.maxDate ? config.maxDate : null;
				startDateFieldName = config.startDateFieldName ? config.startDateFieldName : null;
				endDateFieldName = config.endDateFieldName ? config.endDateFieldName : null;
				form = config.form ? config.form : null;
			}

			this.isStartDateOpen = false;
			this.isEndDateOpen = false;

			this.load(startDate, endDate, minDate, maxDate);

			$rootScope.$watch(angular.bind(this, function() {
				return this.startDate;
			}), angular.bind(this, function(newValue, oldValue) {
				if(newValue !== oldValue) {
                    this.minEndDate = newValue ? newValue : this.minDate;
                }
			}));

			$rootScope.$watch(angular.bind(this, function() {
				return this.endDate;
            }), angular.bind(this, function(newValue, oldValue) {
                if(newValue !== oldValue) {
                    this.maxStartDate = newValue ? newValue : this.maxDate;
                }
			}));

			if(form && startDateFieldName && endDateFieldName) {
				$rootScope.$watch(function(){
					var dateDisabledArray = form.$error["date-disabled"];
					if(dateDisabledArray) {
						return dateDisabledArray.length;
					}
					return 0;
				}, angular.bind(this, function(newVal) {
					var dateDisabledArray = form.$error["date-disabled"];
					if(newVal > 0) {
						for(var i=0; i<dateDisabledArray.length; i++) {
							//this only operates on two date pickers now, so no need to look further in the createBookingForm.
							//we'd need to augment this if we were using more datepickers
							if (dateDisabledArray[i].$viewValue === form[startDateFieldName].$viewValue) {
								form[startDateFieldName].$setValidity('dateRange', !(dateDisabledArray[i].$error["date-disabled"]));
							}
							else {
								form[endDateFieldName].$setValidity('dateRange', !(dateDisabledArray[i].$error["date-disabled"]));
							}
						}
					} else {
						form[startDateFieldName].$setValidity('dateRange', true);
						form[endDateFieldName].$setValidity('dateRange', true);
					}
				}));
			}
			else {
				console.log('The DateRangePicker cannot support validation indicators without having been provided the formObj and the field names.');
			}
		}

		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.startDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object created to match the date selected by the user in the start date field.
		 * @description
		 * The startDate property is used as the model variable bound to the start date input field.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.endDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object created to match the date selected by the user in the end date field.
		 * @description
		 * The endDate property is used as the model variable bound to the end date input field.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.minDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the minimum valid date for the date range.
		 * @description
		 * The minDate property defines the minimum date that should be selectable as the start date for the range.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.maxDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the maximum valid date for the date range.
		 * @description
		 * The maxDate property defines the maximum date that should be selectable as the end date for the range.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.minStartDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the minimum valid date for the start date field.
		 * @description
		 * The minStartDate property defines the minimum date that should be selectable in the start date field.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.maxStartDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the maximum valid date for the start date field.
		 * @description
		 * The maxStartDate property defines the maximum date that should be selectable in the start date field.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.minEndDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the minimum valid date for the end date field.
		 * @description
		 * The minEndDate property defines the minimum date that should be selectable in the end date field.
		 */
		/**
		 * @ngdoc property
		 * @name WcDateRangePickerPrototype.maxEndDate
		 * @propertyOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @returns {Date} The Date object used to identify the maximum valid date for the end date field.
		 * @description
		 * The maxEndDate property defines the maximum date that should be selectable in the end date field.
		 */
		WcDateRangePickerPrototype.prototype.load = function(startDate, endDate, minDate, maxDate) {
			this.startDate = startDate || null; //The day the start datepicker defaults to
			this.endDate = endDate || null; //The day the end datepicker defaults to

			this.minDate = minDate || null; //The minimum day the start datepicker can have
			this.maxDate = maxDate || null; //The maximum day the end datepicker can have

			this.minStartDate = this.minDate;
			this.maxStartDate = this.endDate ? this.endDate : this.maxDate; //TODO: verify endDate <= maxDate

			this.minEndDate = this.startDate ? this.startDate : this.minDate; //TODO: verify startDate >= minDate
			this.maxEndDate = this.maxDate;
		};

		/**
		 * @ngdoc method
		 * @name WcDateRangePickerPrototype.openStartDate
		 * @methodOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @param {Event} $event Event object describing what happened when the function was called.
		 * @description
		 * The WcDateRangePickerPrototype provides an openStartDate function to appropriately trigger the date picker control
		 * to open and to keep track of open status of the control.
		 */
		WcDateRangePickerPrototype.prototype.openStartDate = function($event) {
			$event.preventDefault();
			$event.stopPropagation();

			if (this.isStartDateOpen === true) {
				this.isStartDateOpen = false;
			} else {
				this.isStartDateOpen = true;
				this.isEndDateOpen = false;
			}
		};

		/**
		 * @ngdoc method
		 * @name WcDateRangePickerPrototype.openEndDate
		 * @methodOf WebCoreModule.service:WcDateRangePickerPrototype
		 * @param {Event} $event Event object describing what happened when the function was called.
		 * @description
		 * The WcDateRangePickerPrototype provides an openEndDate function to appropriately trigger the date picker control
		 * to open and to keep track of open status of the control.
		 */
		WcDateRangePickerPrototype.prototype.openEndDate = function($event) {
			$event.preventDefault();
			$event.stopPropagation();

			if (this.isEndDateOpen === true) {
				this.isEndDateOpen = false;
			} else {
				this.isEndDateOpen = true;
				this.isStartDateOpen = false;
			}
		};

		return WcDateRangePickerPrototype;
	}]);